export default function Card({ title, value }) {
  return (
    <div className="glass p-6 rounded-2xl text-center hover:scale-105 hover:border-violet-400/40 transition-all">
      <p className="text-3xl font-bold grad-text mb-2">{value}</p>
      <h4 className="text-sm font-medium text-gray-300">{title}</h4>
    </div>
  );
}
